"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class SymbolizerUtil
 */
var SymbolizerUtil = /** @class */ (function () {
    function SymbolizerUtil() {
    }
    /**
     * Generates a symbolizer (with kind Mark with wellknownName Circle if none provided).
     * @param {SymbolizerKind} kind An optional SymbolizerKind
     * @param {object} values Optional values
     */
    SymbolizerUtil.generateSymbolizer = function (kind, values) {
        switch (kind) {
            case 'Mark':
                return __assign({}, SymbolizerUtil.markSymbolizer, values);
            case 'Icon':
                return __assign({}, SymbolizerUtil.iconSymbolizer, values);
            case 'Fill':
                return __assign({}, SymbolizerUtil.fillSymbolizer, values);
            case 'Line':
                return __assign({}, SymbolizerUtil.lineSymbolizer, values);
            case 'Text':
                return __assign({}, SymbolizerUtil.textSymbolizer, values);
            case 'Raster':
                return __assign({}, SymbolizerUtil.rasterSymbolizer, values);
            default:
                return __assign({}, SymbolizerUtil.defaultSymbolizer, values);
        }
    };
    SymbolizerUtil.markSymbolizer = {
        kind: 'Mark',
        wellKnownName: 'Circle',
        color: '#0E1058'
    };
    SymbolizerUtil.iconSymbolizer = {
        kind: 'Icon',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Parking_icon.svg/128px-Parking_icon.svg.png'
    };
    SymbolizerUtil.fillSymbolizer = {
        kind: 'Fill',
        color: '#0E1058'
    };
    SymbolizerUtil.lineSymbolizer = {
        kind: 'Line',
        color: '#0E1058',
        width: 3
    };
    SymbolizerUtil.textSymbolizer = {
        kind: 'Text',
        label: 'Your Label',
        size: 12
    };
    SymbolizerUtil.rasterSymbolizer = {
        kind: 'Raster'
    };
    SymbolizerUtil.defaultSymbolizer = SymbolizerUtil.markSymbolizer;
    return SymbolizerUtil;
}());
exports.default = SymbolizerUtil;
//# sourceMappingURL=SymbolizerUtil.js.map